import { render, staticRenderFns } from "./SmsConfigTelnyx.vue?vue&type=template&id=685e6303&"
import script from "./SmsConfigTelnyx.vue?vue&type=script&lang=js&"
export * from "./SmsConfigTelnyx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports